var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 134,
    viewBox: "0 0 229 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.965 126.161C157.939 104.793 159.064 72.026 119.398 35.2797C113.645 29.9375 110.833 22.4974 105.123 18.4962C87.8209 6.36281 63.5324 8.82842 48.2413 26.8447C39.8712 36.7072 36.4972 50.2464 27.8026 59.9142C18.0483 70.7716 6.3691 81.3261 1.93532 96.1198C-1.00611 105.917 -0.508663 116.602 2.84371 126.183C51.0313 134.748 96.5803 137.386 135.965 126.161Z",
    fill: "#E7FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 5.5C134.652 5.5 159.5 30.3482 159.5 61V93.5H48.5V61C48.5 30.3482 73.3482 5.5 104 5.5Z",
    fill: "#028383",
    stroke: "#028383"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 80.5C119.436 80.5 133.395 82.0091 143.48 84.4404C148.527 85.657 152.576 87.098 155.352 88.6797C158.166 90.2836 159.5 91.9309 159.5 93.5C159.5 95.0691 158.166 96.7164 155.352 98.3203C152.576 99.902 148.527 101.343 143.48 102.56C133.395 104.991 119.436 106.5 104 106.5C88.5637 106.5 74.605 104.991 64.5195 102.56C59.4729 101.343 55.4236 99.902 52.6484 98.3203C49.8344 96.7164 48.5 95.0691 48.5 93.5C48.5 91.9309 49.8344 90.2836 52.6484 88.6797C55.4236 87.098 59.4729 85.657 64.5195 84.4404C74.605 82.0091 88.5637 80.5 104 80.5Z",
    fill: "#7BD4DC",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.15 25.8027L167.576 23.0093C168.006 22.894 168.361 23.3565 168.138 23.7423L160.86 36.3485C160.637 36.7342 160.992 37.1967 161.422 37.0814L171.847 34.288",
    stroke: "#028383",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.952 18.6953L190.241 14.8666C190.671 14.7513 191.026 15.2138 190.803 15.5996L180.697 33.1047C180.474 33.4905 180.829 33.953 181.259 33.8377L195.548 30.009",
    stroke: "#028383",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.034 8.37695L220.533 2.34831C220.964 2.23302 221.319 2.6955 221.096 3.08127L204.979 30.9967C204.756 31.3825 205.111 31.845 205.541 31.7297L228.04 25.7011",
    stroke: "#028383",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/NoActivity.3069401bb36c15abb0e9cd40c0c54e30.svg";
export { ForwardRef as ReactComponent };